import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-simple',
  templateUrl: './layout-simple.component.html',
})
export class LayoutSimpleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
